
import WarehouseIcon from '@mui/icons-material/Warehouse';

export const relationProductConfig = (productTotals, showCountingStrategies) => {
    return {
        productOverview:  {
            title: 'products',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(productTotals?.belowSafetyStock > 0 && {
                count: productTotals.belowSafetyStock,
                countHelper: 'products_below_safety_stock'
            })
        },
        virtualProductOverview: {
            title: 'virtual_products',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            //mobileactions added later
        },
        unmatchedProducts: {
            title: 'unmatched_products',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        batches: {
            title: 'batches',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        lots: {
            title: 'lots',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
        },
        carriers: {
            title: 'shipping_materials',
            icon: <WarehouseIcon/>,
            isSingleDataGrid: true,
            ...(productTotals?.carrierBelowSafetyStock > 0 && {
                count: productTotals.carrierBelowSafetyStock,
                countHelper: 'carriers_below_safety_stock'
            })
        },
        ...(showCountingStrategies && {
            countingStrategies: {
                title: 'stock_counts',
                icon: <WarehouseIcon/>,
                isSingleDataGrid: true,
            }
        })
    }
};
